/** @jsx React.createElement */
/** @jsxFrag React.Fragment */

import { Client } from 'typesense'
import {Autocomplete} from './index/autocomplete'
import {useTranslation} from "react-i18next";
import React from 'react';

let typesenseClient = new Client({
    apiKey: "Fp1Y8sXZFqHK4Kof4OKQqrQdiUnGygtt",
    nodes: [
        {
            host: "jgq5rlk683nmvbe7p-1.a1.typesense.net",
            port: "443",
            path: "",
            protocol: "https",
        },
    ],
    cacheSearchResultsForSeconds: 2 * 60, // Cache search results from server. Defaults to 2 minutes. Set to 0 to disable caching.
})

const ISO = {
    'Austria': 'AT',
    'Belgium': 'BE',
    'Canada': 'CA',
    'Denmark': 'DK',
    'FaroeIslands': 'FO',
    'France': 'FR',
    'Germany': 'DE',
    'Ireland': 'IE',
    'Italy': 'IT',
    'Netherlands': 'NL',
    'Norway': 'NO',
    'Poland': 'PL',
    'Portugal': 'PT',
    'Spain': 'ES',
    'Sweden': 'SE',
    'Switzerland': 'CH',
    'UK': 'GB',
    'USA': 'US'
};

export default function SearchBar(props) {
    const {t, i18n} = useTranslation();
    let filters = props.country ? {} : null
    if (props.country) {
        filters = 'country:=' + ISO[props.country]
    }
    if (props.city) {
        filters += '&& city:=' + props.city
    }
    return (
        <Autocomplete
            placeholder={t('search_bar')}
            openOnFocus={false}
            getSources={async ({query}) => {
                const results = await typesenseClient.collections('stores').documents().search({
                    q: query,
                    query_by: 'store_name,address_line',
                    highlight_full_fields: 'company_name',
                    filter_by: filters
                })
                console.log(results)
                return [
                    {
                        sourceId: 'products',
                        getItems() {
                            return results.hits;
                        },
                        getItemInputValue({item}) {
                            return item.document.name;
                        },
                        templates: {
                            item({item, components}) {
                                return <Hit hit={item.document} components={components}/>;
                            },
                        },
                    },
                ]
            }}
        />
    );

    function Hit({ hit, components }) {
        return ([
                <a className="aa-ItemLink" href={ '/' + i18n.language + '/stores/' + hit.id}>
                    <div className="aa-ItemContent">
                        <div className="aa-ItemIcon">
                            <img
                                src={hit?.cover_picture?.current_url}
                                alt={hit.name}
                                width="80"
                                height="80"
                            />
                        </div>
                        <div className="aa-ItemContentBody">
                            <div className="aa-ItemContentTitle">
                                {components.Highlight({hit: hit, attribute: 'store_name'})}
                            </div>
                            <div className="aa-ItemContentDescription">
                                {components.Snippet({hit: hit, attribute: 'address_line'})}
                            </div>
                        </div>
                    </div>
                    <div className="aa-ItemActions">
                        <button
                            className="aa-ItemActionButton aa-DesktopOnly aa-ActiveOnly"
                            type="button"
                            title="Select"
                        >
                            <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                                <path
                                    d="M18.984 6.984h2.016v6h-15.188l3.609 3.609-1.406 1.406-6-6 6-6 1.406 1.406-3.609 3.609h13.172v-4.031z"
                                />
                            </svg>
                        </button>
                    </div>
                </a>
            ]
        );
    }
}